<template >
<div class="container-fluid" v-if="lesson">
   
   <div class="row">
     <div class="col-md-8 col-sm-12">

    
      <div class="card mb-4"   v-if="lesson.groups && lesson.groups.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h3 class="m-0 font-weight-bold text-primary">Хуваарь оруулах</h3>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сэдэв</th>
                  <th v-for="(group) in lesson.groups">
                    {{group.schoolName}}
                    <br/>
                    {{group.departmentName}}
                    <br/>
                    {{group.programName}}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(topic, index) in topics">
                  <td>{{index+1}}. </td>
                  <td>{{topic.name}}</td>
                  <td v-for="(gdata, gindex) in topic.groups" >
                    <div v-if="gdata && gdata.date" class="bg-success m-0 p-0 text-white">
                      {{gdata.date | formatDate}}

                      <br/>

                      <span v-if="gdata.teacher">
                        {{gdata.teacher.firstName}}
                      </span>
                      <span v-else-if="lesson.teachers && lesson.teachers.length>0">
                        {{lesson.teachers[0].firstName}}
                      </span>

                    </div>
                    <div v-else class="bg-danger text-white">-</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>



      <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
      <hr class="mb-5"/>
      
      <!-- Modal -->
      <div class="modal fade" id="teacherModal" tabindex="-1" role="dialog" aria-labelledby="teacherModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="teacherModalLabel">Багш сонгох</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Сургууль:</label>
                      <select class="form-control" v-model="school" @change="schoolChanged">
                        <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col" v-if="school!=null">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Багш:</label>
                      <select class="form-control" v-model="teacher" >
                        <option v-for="(dep, index) in teachers" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.firstName}}</option>
                      </select>
                    </div>
                  </div>
                </div>
    
         
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addTeacher" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Хуваарь нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
  
          
                <div class="form-group">
                  <label>Өдөр: </label>
                  <input v-model="dayStr" class="form-control" placeholder="Хичээл заагдах өдөр цаг" type="datetime-local">
                </div>
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addProgram" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>

     </div>
     <div class="col-md-4 col-sm-12">
        <div class="col-lg-12">
                <div class="card shadow mb-4">
                  <div class="card-header">
                    <h4>{{lesson.name}}</h4>
                  </div>
                  <div class="card-body">
                    <h4 class="mb-1">Үнэ:
                      <span class='badge badge-success' v-if="lesson.price==null || lesson.price==undefined || lesson.price==0">Free</span>
                      <div v-else>
                        <span class='badge badge-info'>
                          {{lesson.price}}
                          
                        </span>
                      </div>
                    </h4>
                    <button v-if='lesson.price!=null && lesson.price!=undefined && lesson.price>0' class="btn btn-secondary btn-sm">      
                      <router-link :to="{ name: 'LessonPayment', params: { lessonId: lesson.id}}" class="text-white">Төлбөрийн мэдээлэл</router-link>
                    </button>
                    <p>{{lesson.description}}</p>
                    <div class="btn btn-info btn-sm">
                      <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
                    </div>
                    <div class="btn btn-default  btn-sm mx-1 my-2">
                      <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
                    </div>
                    <br/>

                    <br/>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                          {{type}}

                        </button>

                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card shadow mb-4">
                  <div class="card-header">
                    <h4>Мэдээлэл</h4>
                  </div>
                  <div class="card-body">
                    <p style="margin-bottom: 0rem;">Багш:<span style="font-weight:bold">{{lesson.profession}}</span></p>
                    <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
                     <vue-qrcode v-if="lesson" :value="lesson.lectureCode.toString()" />
                    <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p>
                  </div>
                </div>
              </div>
      


     </div>
   </div>
</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode'
export default {
    name: "LessonTime",

    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null,
              'price':0,
              'tags':[],
              'shortname':null
            },
            content:{
              'name':null,
              'description':null,
              'videoUrl':null,
              'published':false,
              'startDay':null,
              'endDay':null,
              'code':null,
              'duration':null,
              'shortname':null
            },
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
                        
            display:0,
            tagText:null,
            dayStr:null,
            selectedCell:null,
            selectedTopicIndex:null,
            selectedGroupIndex:null,
            schools:[],
            teachers:[],
            school:null,
            teacher:null

            
        };
    },
    methods: {
        
      _getQA(){

      

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data();
              lesson.id=doc.id;
              this.lesson=lesson;
              this.getTopics();
            
          });

          

      },

      async getTopics(){
        if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
          var topicSnapshot=await fb.db.collection("lessons").doc(this.lesson.id).collection("topics").orderBy("createdAt","asc").get();
          if(topicSnapshot && !topicSnapshot.empty){
            this.topics=[];
            for(const doc of topicSnapshot.docs){
              let object=doc.data();
              object.id = doc.id;
              object.groups=[];
              for(const group of this.lesson.groups){
                var groupTopicDoc=await doc.ref.collection("groups").doc(group.program.id).get();
                
                if(groupTopicDoc.exists){
                  let item=groupTopicDoc.data();
                  item.ref=groupTopicDoc.ref;
                  if(!item || (item && !item.date))
                    item.date=null;
                  if(!item || (item && !item.teacher))
                    item.teacher=null;
                  object.groups.push(item);
                }
                else{
                  let item={date:null, teacher:null};
                  item.ref=groupTopicDoc.ref;
                  object.groups.push(item);

                }

                
              }
              
              this.topics.push(object);
            }
      
          }
          
        }
      },

 
      _addTopic(gdata, i, j){
        this.dayStr=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#exampleModal').modal('toggle');
      },
      _chooseTeacher(gdata, i, j){
        this.teacher=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#teacherModal').modal('toggle');
      },
      
 
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    
      setPublished(value, lesson){

      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },

        _addProgram(){
          if(this.selectedCell && this.dayStr && this.dayStr!=''){
            if(this.selectedCell.exists){
              this.selectedCell.ref.update({
                "date": new Date(this.dayStr)
              });
            }
            else
              this.selectedCell.ref.set({
                "date": new Date(this.dayStr)
              });
            this.selectedCell.date=fb.firestore.Timestamp.fromDate(new Date(this.dayStr));
            
            // if(this.selectedTopicIndex && this.selectedGroupIndex){
            //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
            // }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        _addTeacher(){
          console.log(this.selectedCell);
          console.log(this.teacher);
          if(this.selectedCell && this.teacher){
            var tmp= Object.assign({}, this.teacher);
        
              this.selectedCell.ref.update({
                "teacher": tmp
              });
            this.selectedCell.teacher=tmp;
            this._addTeacherToLesson(tmp);
            // if(this.selectedTopicIndex && this.selectedGroupIndex){
            //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
            // }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        _addTeacherToLesson(teacher){
          var exists=false;
          if(this.lesson && this.lesson.teachers && this.lesson.teachers.length>0){
            for(const t of this.lesson.teachers){
              if(t.reference.id==teacher.reference.id){
                exists=true
                break;
              }
            }
          }
          if(exists==false){
            fb.db.collection("lessons").doc(this.lessonId).update({
              "teachers": fb.firestore.FieldValue.arrayUnion(teacher)
            });
          }
        },
        findStudents(sc, dep, pro){
          fb.db.collection("students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
            for(const studentData of docs.docs){
              
              if(studentData!=null && studentData.exists){
                var studentDetail=studentData.data();
                this.addStudentToLesson(fb.db.collection("lessons").doc(this.lesson.id), studentData, studentDetail);
              }
            }
          });
        },
        _getSchools(){
          fb.db.collection("schools")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                let school = schoolData.data();
                school.id=schoolData.id;
                school.ref=schoolData.ref;
                this.schools.push(school);
            
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        async readSchool(){
            if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
              this._getSchools();
            }
            else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && (this.userProfile['role']=="sts" || this.userProfile['role']=="manager")){
               var cusDoc=await this.userProfile['customer'].get();
                if(cusDoc.exists && cusDoc.data().schools!=null && cusDoc.data().schools!=undefined && cusDoc.data().schools.length>0){
                  for(const scRef of cusDoc.data().schools){
                    scRef.get().then(schoolData=>{
                      let school = schoolData.data();
                      school.id=schoolData.id;
                      school.ref=schoolData.ref;
                      this.schools.push(school);
                    
                    });
                  }
                }
            }
          
            else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && this.userProfile['role']=="teacher"){
                var cusDoc=await this.userProfile['customer'].get();
                if(cusDoc.exists && cusDoc.data().school!=null && cusDoc.data().school!=undefined){

                    cusDoc.data().school.get().then(schoolData=>{
                      let school = schoolData.data();
                      school.id=schoolData.id;
                      school.ref=schoolData.ref;
                      this.schools.push(school);
         
                    });
                  
                }
            }

        },
        schoolChanged(){
          this.teacher=null;
          this.teachers=[];
          fb.db.collection("teachers").where("school", '==', this.school.ref).get().then(docs=>{
            docs.docs.forEach(value=>{
              let teacher={};
              teacher.id=value.id;
              teacher.code=value.data().code;
              teacher.reference=value.ref;
              teacher.firstName=value.data().name;
              teacher.lastName=value.data().lastname;
              teacher.description=value.data().description;
              this.teachers.push(teacher);
            });
          });
        },
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
          this.readSchool();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

